import { render, staticRenderFns } from "./MedicationQuestionType.vue?vue&type=template&id=8a580f22"
import script from "./MedicationQuestionType.vue?vue&type=script&lang=js"
export * from "./MedicationQuestionType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports